import AxleLocation from '../constants/AxleLocation';
import BrakeType from '../constants/BrakeType';
import TirePosition from './TirePosition';

export interface AxleId {__axleId: number}

export default class Axle {
  id!: AxleId;
  location = AxleLocation.FRONT;
  index!: number;
  brakeDiscMinWidth: number | null = null;
  brakeType = BrakeType.DISC;
  positions: Array<TirePosition> = [];

  static withPositions(amount: number, location: AxleLocation, index: number): Axle {
    const axle = new Axle();
    axle.positions.push(...Array.from({ length: amount }, () => new TirePosition()));
    axle.location = location;
    axle.index = index;
    return axle;
  }
}
